<script>
import BaseForm from './base-form';
import Attachment from './attachment';
export default {
    mixins: [BaseForm],
    data: () => ({
        analytics: true,
        communities: [],
        formSuccess: false,
        attachments: new Attachment(),
        picker_state: {disabled: {}},
        fields: {
            service_items: [],
            selected_regions: [],
            selected_communities: ''
        },
        config: {
            service_items: {min: 1, max: 5}
        }
    }),
    computed: {
        serviceItemCount() {
            return !this.fields.service_items ? 0 : this.fields.service_items.length;
        },
        canAddServiceItems() {
            return this.serviceItemCount < this.config.service_items.max;
        },
        regions() {
            return this.fields.selected_regions;
        }
    },
    watch: {
        regions() { this.getCommunities(); }
    },
    mounted() {
        this.boot();
        this.getCommunities();
        this.initServiceItems();
    },
    methods: {
        getCommunities() {
            Tortilla.Xhr.get('api/warranty/communities', {
                region_ids: this.regions
            }).then(res => this.communities = res.data ? res.data.sort((a, b) => {
                return a.name.localeCompare(b.name);
            }) : []);
        },
        initServiceItems() {
            for (let i = 0; i < this.config.service_items.min; i++) {
                this.addServiceItem();
            }
        },
        submit(event) {
            this.beforeSubmit();
            this.recaptchaSubmit().then(() => this.submitForm(event));
        },
        submitForm(event) {
            if(this.attachments.waitingOnUploads()) {
                return requestAnimationFrame(() => this.submitForm(event));
            }

            this.form.post(event.target.action, {
                ...this.fields, ...this.persistents
            })
            .then((result) => {
                this.success(result, event);
                this.initServiceItems();
            })
            .catch(() => this.failure());
        },
        addServiceItem() {
            if(!this.fields.service_items) {
                this.fields.service_items = [];
            }

            this.fields.service_items.push({image: undefined});
        },
        removeServiceItem() {
            this.fields.service_items.pop();
        },
        isServiceItemRequired(key) {
            return key === 0;
        },
        uploadAttachment(event, key) {
            const target = event.target;

            this.attachments.upload(event)
                .then(({data}) => this.successUpload(target, data, {key}))
                .catch(({response}) => this.failureUpload(target, response));
        },
        discardAttachment(id, key) {
            document.getElementById(id).value = '';
            this.fields.service_items[key].image = undefined;
        },
        hasAttachment(key) {
            return !! this.fields.service_items[key].image;
        },
        successUpload(target, data, options) {
            this.fields.service_items[options.key].image = data.key;
        },
        failureUpload(target, error) {
            this.attachments.decrementCount();

            if (error.status && error.status >= 400 && error.status < 500) {
                const errors = {};
                errors[target.id] = error.data[Object.keys(error.data)[0]];
                this.form.errors.fill(errors);
            }
        }
    }
};
</script>
